import { PROFILE_EDIT } from './index';
import { Action } from '../action';
import { ProfileEditForm } from '@shared/core';

export class ProfileEditDestroyAction implements Action {
	readonly type = PROFILE_EDIT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ProfileEditInitAction implements Action {
	readonly type = PROFILE_EDIT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ProfileEditClickSubmitAction implements Action {
	readonly type = PROFILE_EDIT.CLICK_SUBMIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ProfileEditFormUpdateAction implements Action {
	readonly type = PROFILE_EDIT.FORM_UPDATE;
	constructor(
		public payload: ProfileEditForm,
		public correlationId?: number
	) {}
}
